import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import MainLayout from './components/MainLayout';
import Dashboard from './pages/Dashboard';
import SettingsLayout from './pages/SettingsLayout';
import CompanyDetails from './pages/Settings/CompanyDetails';
import InvoiceSettings from './pages/Settings/InvoiceSettings';
import UserManagement from './pages/Settings/UserManagement';
import Backups from './pages/Settings/Backups';
import DateTimeSettings from './pages/Settings/DateTimeSettings';
import TaxProfiles from './pages/Settings/TaxProfiles';
import Logs from './pages/Logs';

import POS from './pages/POS';
import Buyback from './pages/Buyback';
import Inventory from './pages/Inventory';
import UsedInventory from './pages/UsedInventory';
import Invoices from './pages/Invoices';
import Accounting from './pages/Accounting';
import Expenses from './pages/Expenses';
import ExpenseCategories from './pages/ExpenseCategories';
import Reports from './pages/Reports';
import PurchaseProducts from './pages/PurchaseProducts';
import SupplierInvoices from './pages/SupplierInvoices';
import Suppliers from './pages/Suppliers';
import AccountingDashboard from './pages/Accounting/AccountingDashboard';






// Mock Auth Guard for prototype
const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    return token ? children : <Navigate to="/login" />;
};

function App() {
    React.useEffect(() => {
        // Fetch branding for favicon
        axios.get('/api/branding').then(res => {
            if (res.data.logo_url) {
                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                link.href = `/api${res.data.logo_url}`;
            }
        }).catch(() => { });
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />

                <Route path="/" element={
                    <PrivateRoute>
                        <MainLayout />
                    </PrivateRoute>
                }>
                    <Route index element={<Dashboard />} />

                    <Route path="settings" element={<SettingsLayout />}>
                        <Route index element={<Navigate to="company" replace />} />
                        <Route path="company" element={<CompanyDetails />} />
                        <Route path="invoice" element={<InvoiceSettings />} />
                        <Route path="users" element={<UserManagement />} />
                        <Route path="backups" element={<Backups />} />
                        <Route path="time" element={<DateTimeSettings />} />
                        <Route path="tax-profiles" element={<TaxProfiles />} />
                    </Route>

                    <Route path="logs" element={<Logs />} />

                    {/* Users top level route removed in favor of settings/users */}

                    <Route path="pos" element={<POS />} />
                    <Route path="purchase" element={<PurchaseProducts />} />
                    <Route path="purchase/supplier-invoices" element={<SupplierInvoices />} />
                    <Route path="suppliers" element={<Suppliers />} />
                    <Route path="invoices" element={<Invoices />} />
                    <Route path="buyback" element={<Buyback />} />
                    <Route path="inventory" element={<Inventory />} />
                    <Route path="inventory/used" element={<UsedInventory />} />

                    <Route path="accounting" element={<Accounting />}>
                        <Route index element={<Navigate to="dashboard" replace />} />
                        <Route path="dashboard" element={<AccountingDashboard />} />
                        <Route path="expenses" element={<Expenses />} />
                        <Route path="categories" element={<ExpenseCategories />} />
                        <Route path="reports" element={<Reports />} />
                    </Route>

                    <Route path="*" element={<div style={{ padding: 20 }}>Page Not Found (404)</div>} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
